import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import './termsAndConditionsBlock.scss'
import appConfig from 'app.config'
import { customerDataApiService, logError, nameof } from 'shared'

export async function saveAcceptedToC() {
	if (!['ee', 'lv', 'lt'].includes(appConfig.country)) {
		return
	}

	try {
		await customerDataApiService.addTermsAndConditionAccepted()
	} catch (error: any) {
		logError(error)
	}
}

export interface ITermsAndCondition {
	className?: string
}

const TermsAndConditionBlock = ({ className }: ITermsAndCondition) => {
	const { t, i18n } = useTranslation()

	const redirect = () => {
		switch (appConfig.country) {
			case 'ee':
				if (i18n.language === nameof('ru-EE', appConfig.languages))
					return 'https://tfbank.ee/ru/dokumendid'
				else return 'https://tfbank.ee/dokumendid'
			case 'lt':
				return 'https://tfbank.lt/bendrosios-elektroniniu-paslaugu-teikimo-salygos'
			case 'lv':
				return 'https://tfbank.lv/portala-lietosanas-noteikumi'
			default:
				return '#'
		}
	}

	return (
		<div id="terms-and-condition-content" className={`${className ?? ''}`}>
			<Trans
				t={t}
				i18nKey="LoginTermsAndConditionText"
				components={[
					<span>
						<a target="_blank" href={redirect()} rel="noreferrer">
							terms and conditions
						</a>
					</span>,
				]}
			/>
		</div>
	)
}

export default TermsAndConditionBlock
